<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-text-field v-model="code" placeholder="Mã hồ sơ" clearable flat outlined dense hide-details />
          </v-col>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-select
              :items="departments"
              item-text="title"
              item-value="value"
              v-model="department"
              placeholder="Cơ sở"
              :disabled="disabledDepartmentFilter"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-autocomplete
              v-model="isClassAssigned"
              :items="[
                {t: 'Đã xếp', v: 'true'},
                {t: 'Chưa xếp', v: 'false'},
              ]"
              placeholder="Trạng thái xếp lớp"
              clearable
              flat
              outlined
              dense
              hide-details
              item-text="t"
              item-value="v"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="2">
        <v-btn color="admin" height="40px" width="100%" @click="onFilterChanged" outlined> Tìm kiếm </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col class="d-flex justify-space-between" cols="12" xs="12" sm="12" md="10">
        <v-row class="my-0">
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field
              v-mask="'##/##/####'"
              placeholder="Ngày thanh toán"
              name="login"
              v-model="registeredAt"
              type="text"
              color="primary"
              flat
              outlined
              dense
              validate-on-blur
              hide-details
            />
          </v-col>
          <v-col class="pb-0" cols="12" xs="12" sm="12" md="4">
            <v-autocomplete
              :items="classes"
              v-model="assignedClass"
              placeholder="Lớp được xếp"
              clearable
              flat
              outlined
              dense
              hide-details
              item-text="title"
              item-value="id"
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-text-field v-model="userPhone" placeholder="SĐT tài khoản" clearable flat outlined dense hide-details />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-autocomplete
              v-model="documentStates_exists"
              :items="[
                {t: 'Đã đánh dấu', v: 'true'},
                {t: 'Chưa đánh dấu', v: 'false'},
              ]"
              placeholder="Trạng thái nhập học"
              clearable
              flat
              outlined
              dense
              hide-details
              item-text="t"
              item-value="v"
            />
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-autocomplete
              v-model="isWithdrawn_exists"
              :items="[
                {t: 'Đã rút', v: 'true'},
                {t: 'Chưa rút', v: 'false'},
              ]"
              placeholder="Trạng thái rút HS"
              clearable
              flat
              outlined
              dense
              hide-details
              item-text="t"
              item-value="v"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters('auth', ['user']),
  },
  async created() {
    if (this.user.department === 'both') {
      this.disabledDepartmentFilter = false
      this.department = ''
    } else this.department = this.user.department
    this.classes = await this.fetchClassesIndependent({type: 'Khối 10'})
  },
  data() {
    return {
      classes: [],
      disabledDepartmentFilter: true,
      advancedFilter: false,
      code: '',
      department: '',
      assignedClass: '',
      userPhone: '',
      departments: [
        {title: 'Cơ sở A', value: 'Cơ sở A'},
        {title: 'Cơ sở 1', value: 'Cơ sở 1'},
      ],
      registeredAt: null,
      nth: 2,
      isClassAssigned: '',
      documentStates_exists: '',
      isWithdrawn_exists: '',
    }
  },
  methods: {
    ...mapActions({fetchClassesIndependent: 'assignClass/fetchClassesIndependent'}),
    onFilterChanged() {
      let query = {
        code: this.code ? this.code.trim() : '',
        parentUsername: this.userPhone,
        isClassAssigned: this.isClassAssigned,
        documentStates_exists: this.documentStates_exists,
        assignedClass: this.assignedClass,
        isWithdrawn_exists: this.isWithdrawn_exists,
      }
      if (!this.department || this.department === 'both') query.department_in = ['unset', 'Cơ sở 1', 'Cơ sở A']
      else query.department_in = ['unset', this.department]
      if (this.registeredAt) query['registeredAt'] = this.registeredAt
      this.$emit('onFilterChanged', query)
    },
  },
}
</script>
